var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccordionBlueIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 48,
    viewBox: "0 0 53 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4998 7.46349L47.1248 28.0885V42.55C47.1248 43.9176 46.5815 45.2291 45.6145 46.1961C44.6475 47.1631 43.336 47.7063 41.9685 47.7063H11.031C9.66348 47.7063 8.35197 47.1631 7.38499 46.1961C6.418 45.2291 5.87476 43.9176 5.87476 42.55V28.0885L26.4998 7.46349V7.46349ZM43.6873 4.73755V16.7688L36.8123 9.8938V4.73755C36.8123 4.28171 36.9933 3.84454 37.3157 3.52221C37.638 3.19988 38.0752 3.0188 38.531 3.0188H41.9685C42.4243 3.0188 42.8615 3.19988 43.1838 3.52221C43.5062 3.84454 43.6873 4.28171 43.6873 4.73755Z",
    fill: "#006CB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0697 1.30015C24.7143 0.655723 25.5885 0.293701 26.5 0.293701C27.4115 0.293701 28.2857 0.655723 28.9303 1.30015L51.7794 24.1458C52.1021 24.4685 52.2834 24.9062 52.2834 25.3627C52.2834 25.8191 52.1021 26.2568 51.7794 26.5795C51.4566 26.9023 51.0189 27.0836 50.5625 27.0836C50.1061 27.0836 49.6683 26.9023 49.3456 26.5795L26.5 3.73047L3.65435 26.5795C3.33161 26.9023 2.89389 27.0836 2.43747 27.0836C1.98106 27.0836 1.54333 26.9023 1.2206 26.5795C0.897864 26.2568 0.716553 25.8191 0.716553 25.3627C0.716553 24.9062 0.897864 24.4685 1.2206 24.1458L24.0697 1.30015Z",
    fill: "#006CB7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionBlueIcon2);
export default __webpack_public_path__ + "static/media/accordion-blue-icon2.e5a5f45290df9462cb3d990106608c78.svg";
export { ForwardRef as ReactComponent };